import { Actions } from '@ngrx/effects';

import { Injectable } from '@angular/core';

import { mwCreateApiEffect } from '@core/store/effect.utils';

import { MwNewsApiService } from '../@services/news-api.service';
import * as actions from './news.actions';

@Injectable()
export class NewsEffects {
  requestNews$ = mwCreateApiEffect(
    this.actions$,
    actions.requestNews,
    (item) => this.service.getNews(item.newsCount),
    (items) => actions.newsReceived({ items }),
    (err) => actions.newsReceiveFailed({ err })
  );

  increaseNewsViewsCounter$ = mwCreateApiEffect(
    this.actions$,
    actions.increaseNewsViewsCounter,
    () => this.service.increaseNewsViewsCounter(),
    () => actions.counterIncreased(),
    (err) => actions.counterIncreaseFailed({ err })
  );

  constructor(
    private readonly actions$: Actions,
    private readonly service: MwNewsApiService
  ) {}
}
